import React, { useRef, useEffect } from 'react';
import styles from './Page.module.scss';
import { useAppDarkMode } from '../../hooks';


type Props = {
  title?: string,
  children: React.Node
};

const Page = ({ title, children }: Props) => {
  const { value } = useAppDarkMode(false);
  const pageRef = useRef();

  useEffect(() => {
    // pageRef.current.scrollIntoView();
  });

  return (
    <div ref={pageRef} className={styles['page']}>
      <div className={styles['page__inner']}>
        {title && <h1 className={styles[value ? 'page__dark-title' : 'page__light-title']}>{title}</h1>}
        <div className={styles['page__body']}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Page;